import { render, staticRenderFns } from "./summary-view.vue?vue&type=template&id=1c2e02f0&scoped=true&"
import script from "./summary-view.vue?vue&type=script&lang=js&"
export * from "./summary-view.vue?vue&type=script&lang=js&"
import style0 from "./summary-view.vue?vue&type=style&index=0&id=1c2e02f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e02f0",
  null
  
)

export default component.exports